<form [formGroup]="form" (ngSubmit)="onSubmit()" novalidate class="relay-form">
  <div class="form-group">
    <label for="relay-name">Название</label>

    <input
      id="relay-name"
      type="text"
      class="form-control"
      formControlName="name"
      autocomplete="off"
      autocorrect="off"
      spellcheck="false"
      [attr.aria-invalid]="isInvalid('name')"
      [attr.aria-describedby]="isInvalid('name') ? 'relay-name-error' : null"
    />

    <small id="relay-name-error" class="field-error" *ngIf="isInvalid('name')">
      Укажите название
    </small>
  </div>

  <div class="form-group">
    <label for="relay-ip">IP-адрес</label>

    <input
      id="relay-ip"
      type="text"
      class="form-control"
      formControlName="ipAddress"
      autocomplete="off"
      autocorrect="off"
      spellcheck="false"
      inputmode="decimal"
      placeholder="192.168.0.1"
      [attr.aria-invalid]="isInvalid('ipAddress')"
      [attr.aria-describedby]="isInvalid('ipAddress') ? 'relay-ip-error' : null"
    />

    <small
      id="relay-ip-error"
      class="field-error"
      *ngIf="isInvalid('ipAddress')"
    >
      Укажите корректный IP-адрес (например, 192.168.0.1)
    </small>
  </div>

  <div class="form-group">
    <label for="relay-password">Пароль</label>

    <div class="password-wrapper">
      <input
        id="relay-password"
        [type]="showPassword ? 'text' : 'password'"
        class="form-control"
        formControlName="password"
        autocomplete="new-password"
        placeholder="Введите пароль"
      />

      <button
        type="button"
        class="password-toggle-btn"
        (click)="togglePasswordVisibility()"
        [attr.aria-label]="showPassword ? 'Скрыть пароль' : 'Показать пароль'"
        [title]="showPassword ? 'Скрыть пароль' : 'Показать пароль'"
      >
        <svg
          *ngIf="showPassword"
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
          <circle cx="12" cy="12" r="3" />
        </svg>

        <svg
          *ngIf="!showPassword"
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" />
          <line x1="1" y1="1" x2="23" y2="23" />
        </svg>
      </button>
    </div>
  </div>

  <div class="form-row">
    <div class="form-group">
      <label for="relay-port">Порт</label>

      <input
        id="relay-port"
        type="number"
        class="form-control"
        formControlName="port"
        min="1"
        max="65535"
        step="1"
        inputmode="numeric"
        [attr.aria-invalid]="isInvalid('port')"
        [attr.aria-describedby]="isInvalid('port') ? 'relay-port-error' : null"
      />

      <small
        id="relay-port-error"
        class="field-error"
        *ngIf="isInvalid('port')"
      >
        От 1 до 65535
      </small>
    </div>

    <div class="form-group">
      <label for="relay-polling">Интервал опроса, мс</label>

      <input
        id="relay-polling"
        type="number"
        class="form-control"
        formControlName="pollingIntervalMs"
        min="1000"
        step="1000"
        inputmode="numeric"
        [attr.aria-invalid]="isInvalid('pollingIntervalMs')"
        [attr.aria-describedby]="
          isInvalid('pollingIntervalMs') ? 'relay-polling-error' : null
        "
      />

      <small
        id="relay-polling-error"
        class="field-error"
        *ngIf="isInvalid('pollingIntervalMs')"
      >
        Минимум 1000 мс
      </small>
    </div>
  </div>

  <div class="form-actions">
    <button type="button" class="btn btn-outline" (click)="onCancel()">
      Отмена
    </button>

    <button type="submit" class="btn btn-primary" [disabled]="form.invalid">
      {{ isEdit ? 'Сохранить' : 'Создать' }}
    </button>
  </div>
</form>
